export enum ERoute {
  HOME = "home",
  VIDEO = "video",
  SAVED_VIDEO = "saved-video",
  MY_PLACE = "my-place",
  CHANNEL = "channel",
}

export const ROUTES = [
  {
    href: ERoute.HOME,
    title: "Home",
  },
  {
    href: ERoute.MY_PLACE,
    title: "My Place",
  },
  {
    href: ERoute.VIDEO,
    title: "Videos",
  },
  {
    href: ERoute.SAVED_VIDEO,
    title: "Saved Video",
  },
  {
    href: ERoute.CHANNEL,
    title: "Channel",
  },
  {
    href: ERoute.MY_PLACE,
    title: "My Place",
  },
];
export const SUPPORT_VIDEO_EXTENSIONS = ["webm", "mp4"];
export const SUPPORT_IMAGE_EXTENSIONS = ["png", "jpge", "jpg"];

export const LOCAL_STORAGE_KEYS = {
  SESSIONS_ID: "sessionId",
  CONFIGURE: "configure",
  VIDEO_TIMESTAMP: "timestamp",
  SCREEN_SAVER: "screenSaver",
  MY_PLACE: "myPlace",
  SCREEN_SAVER_TIMEOUT: "screenSaverTimeout",
  RADIUS: "radius",
};

export const QUERY_KEYS = {
  CONFIGS: "config",
  EVENT_LOG: {
    CHANNEL: "channel-log",
    ASSETS: "asset-log",
  },
};

export const FIXED_CHANNEL_KEYS = {
  SCREEN_SAVER: "Screen Saver",
  MY_PLACE: "My Place",
};

export const DEFAULT_CONFIGS = {
  TIMEOUT: "60000",
  RADIUS: "10"
}